<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
  <tui-breadcrumbs [itemsLimit]="10">
    <ng-container *ngFor="let item of breadcrumbs; let last = last; let i = index">
      <ng-container *ngIf="last">
        <strong *tuiItem tuiFade>
          {{ item }}
        </strong>
      </ng-container>
      <ng-container *ngIf="!last">
        <button *tuiItem tuiLink type="button" (click)="navigateTo(i)">
          {{ item }}
        </button>
      </ng-container>
    </ng-container>
  </tui-breadcrumbs>
  <button [routerLink]="['/admin/check-in']" appearance="secondary" tuiButton type="button"
    style="border: 2px solid #e5e7ea; font-weight: 800" [appDisableUnlessPermission]="'SHIFT_CREATE'">
    Schedule a Shift
  </button>
</nav>

<section class="mb-20">
  <div class="mt-5 relative">
    <div class="w-full bg-[#E5EDFF] h-[124px] rounded-t-xl flex items-center justify-end">
      <div *ngIf="nurse" class="h-[32px] w-[65px] rounded-full flex items-center justify-center mr-8"
        [style.background-color]="nurse.active ? '#6BC68A' : '#FF6B6B'">
        <p class="text-[#FFFFFF] text-sm font-bold">
          {{ nurse.active ? "Active" : "Inactive" }}
        </p>
      </div>
    </div>

    <div class="w-full h-[124px] flex items-center">
      <div class="ml-64 flex items-start justify-between w-full">
        <div>
          <div class="flex items-center space-x-3">
            <div class="w-[17px] h-[17px] rounded-full" [style.backgroundColor]="getServiceDurationColor()"></div>
            <p class="text-2xl font-bold m-0 text-[#000000A6]">
              {{ nurse?.name}}

            </p>
          </div>
          <p class="text-[#6B6D80] text-sm font-medium m-0 pt-2">
            Actual Join Date {{ nurse?.registrationDate | date : "MMM d, y" }}
          </p>
          <div class="pt-2 flex items-center gap-2 flex-wrap">
            <span class="inline-block px-3 py-1 rounded text-sm font-bold text-white"
              [style.background-color]="(nurse?.employmentType === 'Permanent' && !isServicePeriodLessThan6Months()) ? '#285CA5' : '#6BC68A'">
              {{ (isServicePeriodLessThan6Months() ? 'Casual' : (nurse?.employmentType || 'Casual')) }}
            </span>
            <span
              *ngIf="nurse?.permanentConversionStatus && nurse?.permanentConversionStatus !== 'None' && !isServicePeriodLessThan6Months()"
              class="inline-block px-3 py-1 rounded text-sm font-semibold text-[#191C30E5] bg-[#E5EDFF]">
              {{ nurse?.permanentConversionStatus === 'Eligible' ? 'Pending' : nurse?.permanentConversionStatus }}
            </span>
          </div>
        </div>
        <button appearance="flat" class="border custom-icon-button" iconStart="@tui.ellipsis-vertical" tuiIconButton
          type="button" [tuiAppearanceState]="open ? 'hover' : null" [tuiDropdown]="content" [(tuiDropdownOpen)]="open"
          [appDisableUnlessPermission]="'NURSE_UPDATE'">
          Open
        </button>

        <ng-template #content>
          <tui-data-list tuiDataListDropdownManager [size]="size">
            <button *ngIf="!nurse.archived" tuiOption type="button" class="dropdown-button"
              [routerLink]="['/admin/nurse/add-edit/', nurse._id]" [appDisableUnlessPermission]="'NURSE_UPDATE'">
              Edit
            </button>
            <button tuiOption type="button" class="dropdown-button" (click)="resetUserPassword(nurse?.email)"
              [appDisableUnlessPermission]="'NURSE_UPDATE'">
              Reset Password
            </button>
            <button tuiOption type="button" class="dropdown-button" (click)="toggleActive()"
              [appDisableUnlessPermission]="'NURSE_UPDATE'">
              {{ nurse?.active ? "Deactivate" : "Activate" }}
            </button>
            <button tuiOption type="button" class="dropdown-button" (click)="toggleArchive()"
              [appDisableUnlessPermission]="'NURSE_UPDATE'">
              {{ nurse?.archived ? "Unarchive" : "Archive" }}
            </button>
          </tui-data-list>
        </ng-template>
      </div>
    </div>
    <div class="w-[180px] h-[180px] rounded-full absolute top-10 left-10">
      <img class="object-cover w-full h-full rounded-full bg-gray-100"
        src="{{ nurse?.profilePic || 'https://api.iconify.design/mdi/account.svg?color=%239ca3af' }}"
        alt="Nurse Profile" />
    </div>
  </div>
  <tui-tabs [(activeItemIndex)]="activeItemIndex" class="gap-5">
    <button tuiTab type="button">Nurse Profile</button>
    <button tuiTab type="button">Attendance</button>
    <button tuiTab type="button">Leave Records</button>
    <button tuiTab type="button">Salary History</button>
  </tui-tabs>

  <div *ngIf="showConversionActions" class="mt-6 p-4 rounded-lg bg-[#FFF8E6] border border-[#F5D565]">
    <p class="text-base font-semibold text-[#191C30E5] m-0 mb-3">
      This nurse is eligible for appointment as a permanent nurse. Please review and either approve or reject the
      appointment.
    </p>
    <!-- <div class="flex gap-3 flex-wrap">
      <button tuiButton type="button" size="s" (click)="requestConversionAction('Approve')"
        [appDisableUnlessPermission]="'NURSE_UPDATE'">
        Approve
      </button>
      <button tuiButton type="button" size="s" appearance="destructive" (click)="requestConversionAction('Reject')"
        [appDisableUnlessPermission]="'NURSE_UPDATE'">
        Reject
      </button>
    </div> -->
    <div class="flex gap-3 flex-wrap">
      <!-- Added appearance="primary" for the blue look -->
      <button
        style="border: 2px solid #e5e7ea; font-weight: 800; padding: 10px 20px; border-radius: 10px; color: #285ca5; cursor: pointer;"
        (click)="requestConversionAction('Approve')" [appDisableUnlessPermission]="'NURSE_UPDATE'">
        Approve
      </button>

      <!-- Kept appearance="destructive" for the red look -->
      <button
        style="border: 2px solid #e5e7ea; font-weight: 800; padding: 10px 20px; border-radius: 10px;color: red; cursor: pointer; "
        (click)="requestConversionAction('Reject')" [appDisableUnlessPermission]="'NURSE_UPDATE'">
        Reject
      </button>
    </div>
  </div>

  <div class="mt-10" *ngIf="activeItemIndex === 0">
    <div class="flex">
      <div class="inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0">
          Personal Information
        </p>
        <p class="text-sm font-semibold text-[#949494D9] my-0">
          View Nurse information
        </p>
      </div>
      <div class="inline-block pl-[5.5rem]">
        <div>
          <p class="text-sm text-[#595959] font-medium my-0">
            {{ nurse?.employmentType === 'Permanent' ? 'EPF Number' : 'Casual ID' }}
          </p>
          <p class="text-[#6B6D80] text-xl font-bold my-0">
            {{ getEmployeeDisplayNumber() }}
          </p>
        </div>
        <div class="pt-5" *ngIf="nurse?.appointmentDate">
          <p class="text-sm text-[#595959] font-medium my-0">Appointment Date</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
            {{ nurse?.appointmentDate | date : "MMM d, y" }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">Email Address</p>
          <p class="text-[#285CA5] text-xl font-semibold my-0">
            {{ nurse?.email }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">
            Phone Number (Whatsapp)
          </p>
          <p class="text-[#285CA5] text-xl font-semibold my-0">
            {{ nurse?.contactNo }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">Address</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
            {{ nurse?.address }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">Date Of Birth</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
            {{ nurse?.dateOfBirth | date : "MMM d, y" }}
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">Age</p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
            {{ nurse?.age }} Years
          </p>
        </div>
        <div class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">
            Service Period
          </p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
            {{ getServicePeriodDisplay(nurse?.registrationDate) }}
          </p>
        </div>
        <div *ngIf="nurse?.rejectionDate != null" class="pt-5">
          <p class="text-sm text-[#595959] font-medium my-0">
            Permanent Approval Rejection Date
          </p>
          <p class="text-[#1B1F3BA6] text-xl font-semibold my-0">
            {{ nurse?.rejectionDate | date : "MMM d, y" }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex mt-5">
      <div class="inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0">
          Guardian Details
        </p>
        <p class="text-sm font-semibold text-[#949494D9] my-0">
          View Contact Person
        </p>
      </div>
      <div class="inline-block pl-[7rem]">
        <div class="flex space-x-20">
          <div>
            <p class="text-sm text-[#595959] font-medium my-0">Name</p>
            <p class="text-[#1B1F3BA6] text-xl font-bold my-0">
              {{ nurse?.gurdianName }}
            </p>
          </div>
          <div>
            <p class="text-sm text-[#595959] font-medium my-0">Phone Number</p>
            <p class="text-[#285CA5] text-xl font-semibold my-0">
              {{ nurse?.gurdianContact }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex mt-8">
      <div class="inline-block">
        <p class="text-base font-medium text-[#3E4A58] my-0 w-[200px]">Notes</p>
        <p class="text-sm font-semibold text-[#949494D9] my-0 w-[200px]">
          View notes
        </p>
      </div>
      <div class="inline-block pl-[45px] lg:pl-[3rem]">
        <div style="border: 1px solid #d1d5db; border-radius: 6px; padding: 16px">
          <p
            class="text-[0.938rem] text-[#1B1F3BA6] font-medium my-0 w-full md:w-full lg:w-full xl:w-[760px] 2xl:w-[960px] h-full">
            {{ nurse?.notes }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-10" *ngIf="activeItemIndex === 1">
    <div class="flex items-center justify-between mb-4 flex-wrap gap-3">
      <p class="text-base font-medium text-[#3E4A58] m-0">Attendance</p>
      <div class="flex items-center gap-3">
        <button tuiButton type="button" size="s" appearance="secondary" (click)="prevAttendanceMonth()">Prev</button>
        <span class="text-sm font-semibold">{{ attendanceMonthLabel }}</span>
        <button tuiButton type="button" size="s" appearance="secondary" (click)="nextAttendanceMonth()">Next</button>
      </div>
    </div>
    <search class="lg:w-[50%] xl:w-[50%] 2xl:w-[40%] mb-5" tuiSearch style="padding-left: 0">
      <fieldset class="border-none" tuiTextfieldSize="m" style="padding-left: 0">
        <div class="flex items-center space-x-4">
          <div class="w-[431px]">
            <tui-input-date-range [(ngModel)]="dateRange" tuiUnfinishedValidator="Finish filling the field">
              Date range filter
            </tui-input-date-range>
          </div>
          <button size="m" tuiButton type="button" (click)="onFilter()" style="padding-left: 40px; padding-right: 40px">
            Filter
          </button>

          <button type="button" tuiButton appearance="outline" (click)="resetFilter()">
            Reset Filter
          </button>
        </div>
      </fieldset>
    </search>
    <div *ngIf="completedShifts.length == 0">
      <p class="text-base font-medium text-[#3E4A58]">
        No Completed Shifts Available!
      </p>
    </div>
    <div class="flex">
      <div *ngIf="completedShifts.length > 0" class="w-full">
        <table tuiTable size="m" class="md:w-full">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">
                Date
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Patient name
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Roster
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Meal Option
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Type
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Address
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Shift Salary
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngFor="let shift of completedShifts">
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#526ED3] text-sm cursor-pointer">
                    {{ getFormattedDate(shift.date) }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.client[0].name }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ shift.rooster }} Hour
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ shift.mealOption }}</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ shift.shiftType }}</p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{
                    (shift.address || "").length > 20
                    ? ((shift.address || "") | slice : 0 : 40) + "..."
                    : (shift.address || "")
                    }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-left: 10px; padding-top: 0; padding-bottom: 0">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    LKR {{ shift.salary | number : "1.2-2" }}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="flex justify-end items-center mt-5">
          <tui-pagination [index]="completedShiftPageIndex - 1" [length]="getCompletedShiftPageCount()"
            (indexChange)="onCompletedShiftPageChange($event + 1)">
          </tui-pagination>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-10" *ngIf="activeItemIndex === 2">
    <div class="flex items-center justify-between mb-4 flex-wrap gap-3">
      <p class="text-base font-medium text-[#3E4A58] m-0">Leave Records</p>
      <div class="flex items-center gap-3">
        <button tuiButton type="button" size="s" appearance="secondary" (click)="prevLeaveMonth()">Prev</button>
        <span class="text-sm font-semibold">{{ leaveMonthLabel }}</span>
        <button tuiButton type="button" size="s" appearance="secondary" (click)="nextLeaveMonth()">Next</button>
      </div>
    </div>

    <!-- Leave Summary Card above table -->
    <div class="mb-6 p-4 bg-[#F8FAFC] border border-[#E2E8F0] rounded-xl flex flex-col gap-3" *ngIf="balance">
      <!-- Permanent Nurse Breakdown -->
      <ng-container *ngIf="balance.annualLeave?.eligible; else casualSummary">
        <div class="flex items-center gap-6 flex-wrap text-sm text-[#475569]">
          <span class="font-bold text-[#1E293B] min-w-[120px]">Day-offs:</span>
          <div>Entitled: <strong class="text-[#0F172A]">{{ balance.dayOffs?.entitled ?? 0 }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Used: <strong class="text-[#0F172A]">{{ balance.dayOffs?.used ?? 0 }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Remaining: <strong class="text-[#2563EB]">{{ balance.dayOffs?.remaining ?? 0 }}</strong></div>
        </div>
        <div class="flex items-center gap-6 flex-wrap text-sm text-[#475569]">
          <span class="font-bold text-[#1E293B] min-w-[120px]">Annual Leaves:</span>
          <div>Entitled: <strong class="text-[#0F172A]">{{ balance.annualLeave?.entitled ?? 0 }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Used: <strong class="text-[#0F172A]">{{ balance.annualLeave?.used ?? 0 }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Remaining: <strong class="text-[#2563EB]">{{ balance.annualLeave?.remaining ?? 0 }}</strong></div>
        </div>
      </ng-container>

      <!-- Casual Nurse Breakdown -->
      <ng-template #casualSummary>
        <div class="flex items-center gap-6 flex-wrap text-sm text-[#475569]">
          <span class="font-bold text-[#1E293B] min-w-[120px]">Day-offs:</span>
          <div>Available: <strong class="text-[#0F172A]">{{ availableCount }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Used: <strong class="text-[#0F172A]">{{ usedCount }}</strong></div>
          <div class="h-4 w-[1px] bg-[#CBD5E1]"></div>
          <div>Remaining: <strong class="text-[#D97706]">{{ remainingCount }}</strong></div>
        </div>
        <div class="text-xs text-[#64748B]">
          Casual nurses — Day-Offs only (5 / month).
        </div>
      </ng-template>
    </div>

    <div *ngIf="leaveRecords.length === 0">
      <p class="text-base font-medium text-[#3E4A58]">No leave records for this month.</p>
    </div>
    <table *ngIf="leaveRecords.length > 0" tuiTable size="m" class="w-full">
      <thead>
        <tr>
          <th tuiTh>Leave Type</th>
          <th tuiTh>Submitted</th>
          <th tuiTh>From - To</th>
          <th tuiTh>Days</th>
          <th tuiTh>Reason</th>
        </tr>
      </thead>
      <tbody tuiTbody>
        <tr *ngFor="let leave of leaveRecords">
          <td tuiTd>{{ leave.leaveType === 'AnnualLeave' ? 'Annual Leave' : 'Day-Off' }}</td>
          <td tuiTd>{{ leave.submittedDate | date : 'MMM d, y' }}</td>
          <td tuiTd>
            {{ leave.fromDate | date : 'MMM d, y' }}
            –
            {{ leave.toDate | date : 'MMM d, y' }}
          </td>
          <td tuiTd>{{ leave.dayCount }}</td>
          <td tuiTd>{{ leave.reason || '—' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="mt-10" *ngIf="activeItemIndex === 3">
    <div *ngIf="salaryRecords.length == 0">
      <p class="text-base font-medium text-[#3E4A58]">Salary Unavailable!</p>
    </div>
    <div *ngIf="salaryRecords.length > 0" class="flex">
      <div class="w-full xl:w-1/3 2xl:w-full">
        <table tuiTable size="m" class="md:w-full lg:w-[37rem] xl:w-[50rem] 2xl:w-[70rem]">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">
                Month
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                No of Shifts
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Salary
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Actions
              </th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngFor="let salaryRecord of salaryRecords">
              <td tuiTd style="padding: 0; padding-left: 10px;">
                <div tuiCell="m">
                  <p [routerLink]="[
                      '/salary',
                      salaryRecord.month,
                      salaryRecord.year
                    ]" class="text-[#526ED3] text-sm cursor-pointer">
                    {{ salaryRecord.monthName }} - {{ salaryRecord.year }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding: 0;padding-left: 10px;">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ salaryRecord.shifts.length }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding: 0;padding-left: 10px;">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ salaryRecord.totalSalary | number : "1.2-2" }} LKR
                  </p>
                </div>
              </td>
              <td tuiTd style="padding: 0;padding-left: 10px;">
                <div tuiCell="m">
                  <p class="text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer"
                    (click)="
                      viewSalaryDetails(
                        nurseId,
                        salaryRecord.month,
                        salaryRecord.year
                      )
                    ">
                    View Details
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          class="flex justify-start items-center mt-5 ml-[300px] md:ml-[570px] lg:ml-[450px] xl:ml-[690px] 2xl:ml-[970px]">
          <tui-pagination [index]="salaryPageIndex - 1" [length]="getSalaryPageCount()"
            (indexChange)="onSalaryPageChange($event + 1)">
          </tui-pagination>
        </div>
      </div>
    </div>
  </div>

</section>

<ng-template [tuiDialogOptions]="{ label: conversionDialogTitle, size: 's' }"
  [(tuiDialog)]="confirmConversionDialogOpen">
  <p class="text-sm mb-4">{{ conversionDialogMessage }}</p>
  <div class="flex justify-end gap-2 flex-wrap">
    <button tuiButton type="button" size="s" appearance="secondary" (click)="onConversionActionCancel()">
      Cancel
    </button>
    <button tuiButton type="button" size="s"
      [appearance]="pendingConversionAction === 'Reject' ? 'destructive' : 'primary'"
      (click)="onConversionActionConfirm()">
      Yes
    </button>
  </div>
</ng-template>